import type { Asset, AssetType, ClientOption } from "../../types";
import {
  formatDate,
  getUpcomingAlerts,
  nearestService,
} from "../../utils/assetDates";
import styles from "./ClientAssetModule.module.css";

type Props = {
  type: AssetType;
  clients: ClientOption[];
  assets: Asset[];
  onSelect: (clientId: string) => void;
};

export default function ClientCards({ type, clients, assets, onSelect }: Props) {
  return (
    <div className={styles.clientGrid}>
      {clients.map((client) => {
        const records = assets.filter((asset) => asset.clientId === client.id);
        const operational = records.filter(
          (asset) => asset.status === "Operational",
        ).length;
        const dueSoon = records.filter(
          (asset) => asset.status === "Due Soon",
        ).length;
        const readiness = records.length
          ? Math.round((operational / records.length) * 100)
          : 0;
        const nearest = records
          .map((asset) => ({ asset, service: nearestService(asset) }))
          .filter((entry) => entry.service)
          .sort((left, right) =>
            left.service!.date.localeCompare(right.service!.date),
          )[0];
        const alerts = getUpcomingAlerts(records).length;

        return (
          <button
            type="button"
            className={styles.clientCard}
            key={client.id}
            onClick={() => onSelect(client.id)}
          >
            <span className={styles.clientCardGlow} aria-hidden="true" />
            <header>
              <span className={styles.clientIcon} aria-hidden="true">
                {type === "Life Raft" ? "◫" : "◇"}
              </span>
              <span className={styles.clientCode}>{client.code}</span>
            </header>
            <div className={styles.clientIdentity}>
              <p>CLIENT ASSET CONTAINER</p>
              <h2>{client.name}</h2>
              <span>
                {records.length} {type.toLowerCase()} record
                {records.length === 1 ? "" : "s"}
              </span>
            </div>
            <div className={styles.readinessTrack}>
              <span style={{ width: `${readiness}%` }} />
            </div>
            <div className={styles.clientMetrics}>
              <span>
                <strong>{readiness}%</strong>
                <small>Ready</small>
              </span>
              <span>
                <strong>{dueSoon}</strong>
                <small>Due soon</small>
              </span>
              <span>
                <strong>{alerts}</strong>
                <small>Email window</small>
              </span>
            </div>
            <footer>
              <span>
                <small>Next service</small>
                <strong>{formatDate(nearest?.service?.date)}</strong>
              </span>
              <b>Open records →</b>
            </footer>
          </button>
        );
      })}
    </div>
  );
}
